const doc = [({"en":({"normal":"Normal", "deleteOnSend":"Delete on send", "archive":"Archive"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;